{
  "腾讯云 IM": "Tencent Cloud IM",
  "SDKAppID": "SDKAppID",
  "IM 管理员账号": "IM administrator",
  "IM 密钥": "IM secret key",
  "IM 应用地区": "IM app region",
  "商家对接会话，保存后立即生效。": "Merchant conversations. Changes take effect immediately.",
  "腾讯云 IM 应用的 SDKAppID。": "The SDKAppID of your Tencent Cloud IM application.",
  "腾讯云 IM 控制台的管理员 UserID。": "The administrator UserID configured in Tencent Cloud IM.",
  "应用的 64 位 SecretKey，加密保存且不回显。": "The application's 64-character SecretKey. Encrypted at rest and never displayed.",
  "与腾讯云 IM 应用所在地区一致。": "Select the region of your Tencent Cloud IM application.",
  "IM 账号管理": "IM account management",
  "IM 账号": "IM account",
  "IM 账号、企业或商家用户": "IM account, company or merchant user",
  "账号用途": "Account purpose",
  "实时通知": "Live notifications",
  "业务会话": "Conversations",
  "关联企业": "Linked company",
  "商家用户": "Merchant user",
  "关联状态": "Link status",
  "未关联": "Not linked",
  "已关联": "Linked",
  "已解绑": "Unlinked",
  "腾讯状态": "Tencent status",
  "未检查": "Not checked",
  "已存在": "Exists",
  "不存在": "Missing",
  "服务异常": "Service error",
  "实时连接数": "Live connections",
  "最近检查": "Last checked",
  "刷新状态": "Refresh status",
  "腾讯状态已刷新": "Tencent status refreshed",
  "请先确认腾讯账号存在": "Confirm that the Tencent account exists first",
  "重新关联": "Relink",
  "关联": "Link",
  "解绑": "Unlink",
  "重试创建": "Retry creation",
  "新增通知账号": "Create notification account",
  "新增通知账号？": "Create a notification account?",
  "将在当前腾讯 IM 应用创建一个通知账号，创建后可关联商家用户。": "Create one notification account in the current Tencent IM app. You can then link it to a merchant user.",
  "IM 账号已创建": "IM account created",
  "解绑此 IM 账号？": "Unlink this IM account?",
  "将结束该账号的实时连接并解除关联。腾讯账号保留，不释放云端账号额度。": "End this account’s live connections and remove its link. The Tencent account remains and still counts toward the account limit.",
  "IM 账号已解绑": "IM account unlinked",
  "请先保存 IM 配置后再管理账号。": "Save the IM configuration before managing accounts.",
  "仅同步平台已知账号，不会导入腾讯应用中的全部账号。": "Sync accounts known to this platform. This does not import every account in the Tencent app.",
  "已同步 {{count}} 个账号": "Synced {{count}} accounts",
  "同步关联账号": "Sync linked accounts",
  "重新关联商家用户": "Relink merchant user",
  "关联商家用户": "Link merchant user",
  "IM 账号已关联": "IM account linked",
  "关联后仅供该企业的此用户接收实时通知；解绑后只能重新关联原用户。": "This account will receive live notifications only for this user in this company. After unlinking, it can only be relinked to the same user.",
  "消息服务尚未配置，请联系平台客服": "Messaging is not configured. Contact platform support.",
  "腾讯 IM 账号不存在": "The Tencent IM account was not found.",
  "账号不属于当前消息服务配置": "This account does not belong to the current messaging configuration.",
  "只能创建本平台新增的通知账号": "Only notification accounts added by this platform can be created.",
  "腾讯 IM 账号操作失败，请重试": "The Tencent IM account operation failed. Please try again.",
  "消息服务账号额度已用尽，请联系平台管理员": "The messaging account limit has been reached. Contact the platform administrator.",
  "请选择企业的有效商家成员": "Select an active merchant member of this company.",
  "业务聊天账号仅支持查看": "Conversation accounts are read-only.",
  "账号只能重新关联原企业和原用户": "This account can only be relinked to its original company and user.",
  "请先创建或刷新确认腾讯账号存在": "Create the Tencent account or refresh its status to confirm that it exists first.",
  "该成员已有关联的通知账号，请先解绑": "This member already has a notification account. Unlink it first.",
  "账号尚未关联商家成员": "This account is not linked to a merchant member.",
  "没有可用的通知账号，请联系平台管理员": "No notification account is available. Contact the platform administrator."
}
